import {useNavigate} from 'react-router-dom';

import {MyPaymentsEnum} from 'presentation/constants';

import type {BemobiMessage, UseBemobiPostMessageParams} from './types';
import {BemobiMessageType, BemobiPaymentStatus} from './types';

const useBemobiPostMessage = ({setIsIframeOpen, setIsPayError}: UseBemobiPostMessageParams) => {
	const navigate = useNavigate();

	const handleBemobiPostMessage = (msg: BemobiMessage) => {
		if (!msg || typeof msg !== 'object') return;

		if (
			msg.type === BemobiMessageType.INTERNAL_SERVER_ERROR ||
			msg.type === BemobiMessageType.READ_SESSION_FAILED
		) {
			setIsIframeOpen(false);
			setIsPayError(true);
			return;
		}

		if (msg.type === BemobiMessageType.PAYMENT_ERROR) {
			setIsIframeOpen(false);
			setIsPayError(true);
			return;
		}

		if (msg.type === BemobiMessageType.OK) {
			if (msg.status === BemobiPaymentStatus.CONFIRMED) {
				setIsIframeOpen(false);
				navigate(MyPaymentsEnum.PAYMENTS_HISTORY, {state: {paymentSuccess: true}});
				return;
			}
			setIsIframeOpen(false);
			setIsPayError(true);
		}
	};

	return {handleBemobiPostMessage};
};

export {useBemobiPostMessage};
